import styled from 'styled-components';
import { Breakpoints } from '../../theme/Theme.constants';

export const MainPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${Breakpoints.maxWidth}px;
  margin: 0 auto;
`;
